import React, { useState, useEffect} from 'react';
import LANG from './lang'
import { getProfileFromToken } from './config';

import config from './config';
import { DeleteIcon, Edit2Icon, PlusSquareIcon, UploadCloudIcon, XIcon, FileIcon, EditIcon, TrashIcon, User2Icon, UserStar, Users2Icon, UserPlus2, X } from 'lucide-react';
import { Modal, Spin, message } from 'antd';


// Componente di utility per le card delle azioni
const ActionCard = ({ title, description, icon, onClick, type = 'info' }) => {
    let bgColor = 'bg-blue-500';
    let hoverColor = 'hover:bg-blue-600';

    if (type === 'danger') {
        bgColor = 'bg-red-500';
        hoverColor = 'hover:bg-red-600';
    } else if (type === 'success') {
        bgColor = 'bg-green-500';
        hoverColor = 'hover:bg-green-600';
    }

    return (
        <div 
            className={`p-4 rounded-xl shadow-lg cursor-pointer transform transition duration-300 ease-in-out ${bgColor} ${hoverColor} text-white flex items-center space-x-4`}
            onClick={onClick}
        >
            <div className="text-3xl">{icon}</div>
            <div>
                <h3 className="font-semibold text-lg">{title}</h3>
                <p className="text-sm opacity-90">{description}</p>
            </div>
        </div>
    );
};

// Componente principale del Pannello Amministrativo
const AdminDashboard = ({handleLogout}) => {
    const l = LANG(localStorage.getItem('appLanguage'));
    const profilo = getProfileFromToken(localStorage.getItem("token"))
    
    // Stato per la navigazione
    const [activeTab, setActiveTab] = useState('dashboard'); 
    
    const [simulatedUsers, setSimulatedUsers] = useState(null);
    const [simulatedChats, setSimulatedChats] = useState(null);
    
    // Stato per la modifica utente
    const [editingUser, setEditingUser] = useState(null);

    const [pdfVisible, setPdfVisible] = useState(false);
    const [currentPdfUrl, setCurrentPdfUrl] = useState('');
    const [loadingPdf, setLoadingPdf] = useState(false);

    // --- LOGICA GESTIONE UTENTI ---

    const handleUserToggleAccess = (id) => {
        setSimulatedUsers(users => users.map(u => 
            u.id === id ? { ...u, isActive: !u.isActive } : u
        ));
    };

    const handleUserDelete = async (id) => {
        if (window.confirm(l.ADMIN_USERS_CONFIRM_DELETE)) {
           await fetch(config.apiUrl+'/user/delete/'+id, {
                        method: 'GET',
                        
                        });
                    
             
             handleUserupdateResposne()
        }
    };
    
    const handleUserCreate = async () => {
       
        const newName = prompt(l.ADMIN_USERS_PROMPT_CREATE);
        if (newName) {
            const FD = new FormData()
       
            FD.append("email", newName)
           
            console.log(FD)
            await fetch(config.apiUrl+'/user/add', {
                        method: 'POST',
                        body: FD 
                        });
                    
             
             handleUserupdateResposne()
          
        }
    };




    const handleSaveUserEdit = (e) => {
        e.preventDefault();
        onSaveUser({editingUser}); 
        
        setEditingUser(null);
    };


   const onSaveUser = async (ch1) =>
    {               
            let ch = ch1.editingUser
            console.log(ch)
            const FD = new FormData()
            FD.append("nome", ch.nome)
            FD.append("cognome", ch.cognome)
            FD.append("email", ch.email)
            FD.append("password", ch.password)
            FD.append("profilo", ch.profilo)
            console.log(FD)
            await fetch(config.apiUrl+'/user/update', {
                        method: 'POST',
                        body: FD 
                        });
                    
             
             handleUserupdateResposne()
             
    }

    /* aggiungi utent a chat*/
    const handleAddUser = async (userid, chatid) => {
       
            const FD = new FormData()
       
            
            FD.append("idutente", userid)
            FD.append("idchat", chatid)
            
            await fetch(config.apiUrl+'/user/adduserschat', {
                        method: 'POST',
                        body: FD 
                        });
            handleUserchataddResposne()       
             
             
          
        
    };

    const handleRemoveUser = async (userid, chatid) => {
       
            const FD = new FormData()
       
            
            FD.append("idutente", userid)
            FD.append("idchat", chatid)
            
            await fetch(config.apiUrl+'/user/deluserschat', {
                        method: 'POST',
                        body: FD 
                        });
                    
             
            handleUserchatdelResposne()
          
        
    };



 /*      const handleSubmitConfig = (e) => {
        e.preventDefault();
        console.log("Salvataggio configurazione chat:", formData);
        setIsUploading(true);
        onSave({ ...chatConfig, ...formData }); 
        setIsUploading(false);
        setSelectedFiles([]);
        setEditing(false)
    };
*/


    useEffect(() => {
            try
            {
                var defurl
                if (profilo === 'user')
                    defurl = config.apiUrl+"/chat/getactive?current_user="+ localStorage.getItem("email")
                else if (profilo === 'admin') 
                        defurl = config.apiUrl+"/chat/getactive"                    
                //fetch(config.apiUrl+"/chat/getactive?current_user="+ localStorage.getItem("email"), {
                fetch(defurl, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json" ,
                        },
                        body: JSON.stringify()
                        }).then((res) => res.json())
                    .then((allData) => setSimulatedChats(allData))
                    .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
                
            } catch (err) {
                //do something
            }

                try
                {
                    fetch(config.apiUrl+"/user/get", {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json" ,
                        },
                        body: JSON.stringify()
                        }).then((res) => res.json())
                    .then((allData) => setSimulatedUsers(allData))
                    .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
                } catch (err) {
                    //do something
                }
        }, []);

    const handleUserupdateResposne =() =>{
            try
            {
                fetch(config.apiUrl+"/user/get", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                    body: JSON.stringify()
                    }).then((res) => res.json())
                .then((allData) => setSimulatedUsers(allData))
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {
                //do something
            }
            
    };

    
    const handleUserchataddResposne =() =>{
          setAddingUser(false)
          
    };
    const handleUserchatdelResposne =() =>{
          setViewUsersList(false)

    };


       
    const renderUserManagement = () => (
        <div className="p-4">
            <h2 className="text-2xl font-bold mb-4 text-gray-700">{l.ADMIN_TAB_USERS}</h2>
            <button 
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg mb-4 transition duration-200"
                onClick={handleUserCreate}
            >
               {l.ADMIN_USERS_BTN_CREATE}
            </button>
            
            {editingUser && (
                <div className="p-4 mb-6 rounded-lg shadow-inner bg-blue-50 border border-blue-200">
                    <h3 className="text-xl font-semibold mb-3">{l.ADMIN_LABEL_EMAIL} {editingUser.email}</h3>
                    <form onSubmit={handleSaveUserEdit} className="grid grid-cols-2 gap-4">
                        <div className="flex flex-col">
                            <label className="font-medium text-sm">{l.ADMIN_LABEL_NAME}:
                                
                            <input id="nome" name = "nome" type="text" value={editingUser.nome} onChange={handleUserChange} className="p-2 border rounded"  />
                            </label>
                        </div>
                        <div className="flex flex-col">
                            <label className="font-medium text-sm">{l.ADMIN_LABEL_SURNAME}:</label>
                            <input name = "cognome" type="text" value={editingUser.cognome} onChange={handleUserChange}className="p-2 border rounded"  />
                        </div>
                         <div className="flex flex-col">
                            <label className="font-medium text-sm">{l.ADMIN_LABEL_EMAIL}:</label>
                            <input name = "email" type="text" disabled value={editingUser.email} onChange={handleUserChange} className="p-2 border rounded"  />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-medium text-sm">{l.ADMIN_LABEL_PASSWORD}:</label>
                            <input name = "password" type="text" value={editingUser.password} onChange={handleUserChange} className="p-2 border rounded"  />
                        </div>
                        <div className="flex items-center space-x-3 mt-4">
                            <label className="font-medium">{l.ADMIN_LABEL_PERMISSION}:</label>
                            <input name = "profilo" type="text" value={editingUser.profilo} onChange={handleUserChange} className="p-2 border rounded"  />
                        </div>
                        
                        <div className="col-span-2 flex justify-end space-x-4 mt-4">
                            <button type="button" onClick={() => setEditingUser(null)} className="cancel-button">{l.ADMIN_BTN_CANCEL}</button>
                            <button type="submit" className="save-button">{l.ADMIN_BTN_SAVE_CHANGES}</button>
                        </div>
                    </form>
                </div>
            )}
                        
            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{l.ADMIN_LABEL_NAME}</th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">{l.ADMIN_LABEL_SURNAME}</th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">{l.ADMIN_LABEL_EMAIL}</th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">{l.ADMIN_LABEL_PERMISSION}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {simulatedUsers.map(user => (
                            <tr key={user.id} className={user.isActive ? '' : 'bg-red-50 opacity-70'}>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-900">{user.nome}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-center">
                                    
                                    <div className="text-sm font-medium text-gray-900">{user.cognome}</div>
                                </td>
                                 <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-900">{user.email}</td>
                                 <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-900">
                                  {user.profilo}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex justify-center space-x-3">
                                    <button 
                                        onClick={() => setEditingUser(user)} 
                                        className="text-blue-600 hover:text-blue-900 transition duration-150"
                                        title={l.ADMIN_ACTION_MODIFY}
                                        >
                                        ??
                                    </button>
                                    
                                    <button 
                                        onClick={() => handleUserDelete(user.email)} 
                                        className="text-red-600 hover:text-red-900 transition duration-150"
                                        title={l.ADMIN_ACTION_DELETE_USER}
                                        >
                                        ???
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
        </div>
        
    );

    // --- LOGICA GESTIONE CHAT ---

    const apriPdf = async (chatid, nomefile) => {
        setLoadingPdf(true);
        const url = config.apiUrl+"/download/"+chatid+"/"+nomefile;
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Errore nel download");
            const blob = await response.blob();
            
            //const blobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            const blobUrl = (nomefile.toLowerCase().endsWith('.pdf') ? URL.createObjectURL(new Blob([blob], { type: 'application/pdf' })) : URL.createObjectURL(new Blob([blob], { type: 'text/plain' })));
            setCurrentPdfUrl(blobUrl);
            setPdfVisible(true);
        } catch (error) {
            message.error("Impossibile caricare il PDF");
        } finally {
            setLoadingPdf(false);
        }
    };

    const chiudiPdf = () => {
        setPdfVisible(false);
        if (currentPdfUrl.startsWith('blob:')) URL.revokeObjectURL(currentPdfUrl);
        setCurrentPdfUrl('');
    };
    const handlequeryResponse =() =>{
            try
            {
                var defurl
                if (profilo === 'user')
                    defurl = config.apiUrl+"/chat/getactive?current_user="+ localStorage.getItem("email")
                else if (profilo === 'admin')
                        defurl = config.apiUrl+"/chat/getactive"
                        
                fetch(defurl, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                    }).then((res) => res.json())
                .then((allData) => setSimulatedChats(allData))
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {
                // error
            }
            
    };

    const handleChatDelete = (id) => {
        setEditing(false);
        if (window.confirm(l.ADMIN_CHATS_CONFIRM_DELETE)) {
            try
            {
                var defurl;
                if (profilo === 'admin')
                    defurl = config.apiUrl+"/chat/chatop?action=delete&chatid="+id
                else if (profilo === 'user')
                        defurl = config.apiUrl+"/chat/chatop?action=delete&current_user="+ localStorage.getItem("email")+"&chatid="+id

                fetch(defurl, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                }).then((res) => {res.json()
                    handlequeryResponse() 
                    })
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {
                handlequeryResponse() 
            }
            if (profilo === 'user') 
                setSimulatedChats(chats => chats.filter(c => c.id !== id));
            else if (profilo === 'admin')
                setSimulatedChats(chats => chats.filter(c => c.id !== 0));
        }
    };
    
    const handleCreateResponse = () => {
        // Handle create response logic
        handlequeryResponse()

    }
    const handleChatCreateEmpty = () => {
            try
            {
                fetch(config.apiUrl+"/chat/chatop?action=create&current_user="+ localStorage.getItem("email"), {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json" ,
                    },
                }).then((res) => {res.json()
                    handleCreateResponse() 
                    })
                .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
            } catch (err) {
                handleCreateResponse() 
            }
    };


        const [isEditing, setEditing] = useState(false);
        const [selectedFiles, setSelectedFiles] = useState([]);
        const [isUploading, setIsUploading] = useState(false);
        const [chatConfig, setChatConfig] = useState([]);
        const [chatFileList, setChatFileList] = useState([])
        const [formData, setFormData] = useState();
        const [viewUsersList, setViewUsersList] = useState(false);
        const [usersList, setUsersList] = useState();
        const [usersAddList, setUsersAddList] = useState();
        const [addingUser, setAddingUser] = useState(false);
        const [currentChat, setCurrentChat] = useState(-1)
        
    // Handler per i campi di testo
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const handleUserChange = (e) => {
        const { name, value } = e.target;
        setEditingUser(prev => ({ ...prev, [name]: value }));
    };

     const handleFileChange = (e) => {
        console.log(e.target.files)
        if (e.target.files && e.target.files.length > 0) {
            const newFiles = Array.from(e.target.files);
            setSelectedFiles(prevFiles => [...prevFiles, ...newFiles]);
        }
        e.target.value = null; 
    };


    // Handler per rimuovere un file dalla lista
    const handleRemoveFile = (index) => {
        setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    };

    const onSave = async (ch) =>
    {
            console.log(ch)
            const FD = new FormData()
            FD.append("id", ch.id)
            FD.append("titolo", ch.titolo)
            FD.append("stato", ch.stato)
            FD.append("username", ch.username)
            FD.append("cfgprompt", ch.cfgprompt)
            FD.append("cfgname", ch.cfgname)
            FD.append("cfgschema", ch.cfgschema)
            if (selectedFiles.length >0){

                selectedFiles.forEach(file => {
                    FD.append("files", file); 
                });
            }
            await fetch(config.apiUrl+'/chat/chatmodify', {
                        method: 'POST',
                        body: FD 
                        });
                    
             
             handlequeryResponse()
             handleChatEdit(ch.id);
    }
    const onCancel = () =>
    {
        setEditing(false)
    }
    const handleSubmitConfig = (e) => {
        e.preventDefault();
        console.log("Salvataggio configurazione chat:", formData);
        setIsUploading(true);
        onSave({ ...chatConfig, ...formData }); 
        setIsUploading(false);
        setSelectedFiles([]);
        setEditing(false)
    };

    /* Handler per l'upload (simulato) dei file*/
    const handleUploadFiles = async () => {
        if (selectedFiles.length === 0) {
            console.log("Nessun file selezionato.");
            return;
        }

        setIsUploading(true);
        // Logica di upload simulata o reale
        
        setTimeout(() => {
            setIsUploading(false);
            setSelectedFiles([]); 
            console.log("Upload completato.");
        }, 1500);
    };
    
    const handleUserAdd = (chatId) =>{
        if (viewUsersList)
            setViewUsersList(false)
        if (addingUser)
        {
            setAddingUser(false)
            return
        }
        try
        {
            fetch(config.apiUrl+"/user/getsimple?chatid="+chatId, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json" ,
                },
                body: JSON.stringify()
                }).then((res) => res.json())
            .then((allData) => {
                                setAddingUser(true)
                                setUsersAddList(allData)
                                setCurrentChat(chatId)
            })
            .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
        } catch (err) {
            //do something
        }

    }
    const handleListUsers = (chatId) =>{
        if (addingUser)
            setAddingUser(false)
        if (viewUsersList)
        {
            setViewUsersList(false)
            return
        }
        
        try
        {
            fetch(config.apiUrl+"/chat/chatop?action=getusers&current_user="+ localStorage.getItem("email")+"&chatid="+chatId, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json" ,
                },
                body: JSON.stringify()
                }).then((res) => res.json())
            .then((allData) => {
                                setViewUsersList(true)
                                setUsersList(allData)
                                setCurrentChat(chatId)
            })
            .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
        } catch (err) {
            //do something
        }

    }
    const handleChatEdit = (chatId) =>{
        if (isEditing)
        {
            setEditing(false)
            return
        }

        try
        {
            var defurl  
            if (profilo === 'admin')
                defurl = config.apiUrl+"/chat/chatop?action=get&chatid="+chatId
            else if (profilo === 'user')    
                    defurl = config.apiUrl+"/chat/chatop?action=get&current_user="+ localStorage.getItem("email")+"&chatid="+chatId            

            fetch(defurl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json" ,
                },
                body: JSON.stringify()
                }).then((res) => res.json())
            .then((allData) => {setEditing(true)
                                setChatConfig(allData[0])
                                setFormData(allData[0])
                                setChatFileList(allData[1])
            })
            .catch((error) => console.error("Errore nel fetch dei dettagli:", error));
        } catch (err) {
            //do something
        }
    }
    const renderChatManagement = () => (
        <div className="p-4">

            <h2 className="text-2xl font-bold mb-4 text-gray-700">{l.ADMIN_CHATS_TITLE}</h2>
            <button 
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg mb-4 transition duration-200"
                onClick={() =>handleChatCreateEmpty()}
            >
                <PlusSquareIcon /> {l.ADMIN_CHATS_BTN_CREATE_EMPTY}
            </button>
            <div className="overflow-x-auto bg-gray rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{l.ADMIN_CHATS_HEADER_TITLE}</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{l.ADMIN_CHATS_HEADER_OWNER}</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{l.ADMIN_CHATS_HEADER_STATUS}</th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">{l.ADMIN_CHATS_HEADER_ACTIONS}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-gray divide-y divide-gray-200">
                        {simulatedChats.map(chat => (
                            <tr key={chat.id}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{chat.titolo}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{chat.username}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{chat.stato}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                    <button 
                                        onClick={() => handleChatDelete(chat.id)} 
                                        className="text-red-600 hover:text-red-900 transition duration-150"
                                        title={l.ADMIN_CHATS_ACTION_DELETE}
                                    >
                                        <TrashIcon/>
                                    </button> 
                                    <button 
                                        onClick={() => handleChatEdit(chat.id)} 
                                        className="text-red-600 hover:text-red-900 transition duration-150"
                                        title={l.ADMIN_CHATS_ACTION_EDIT}
                                    >
                                        <EditIcon/>
                                    </button>

                                    <button 
                                        onClick={() => handleUserAdd(chat.id)} 
                                        className="text-red-600 hover:text-red-900 transition duration-150"
                                        title={l.ADMIN_CHATS_ACTION_EDIT}
                                        >
                                            <UserPlus2/>
                                    </button>
                                    <button 
                                        onClick={() => handleListUsers(chat.id)} 
                                        className="text-red-600 hover:text-red-900 transition duration-150"
                                        title={l.ADMIN_CHATS_ACTION_EDIT}
                                        >
                                        <Users2Icon/>
                                            
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        {viewUsersList  &&
                <div className="file-list">
                    <strong>{l.USERS_CONFIG_LIST}</strong>
                    {usersList.length === 0 ? (
                        <p>{l.USERS_CONFIG_LIST_EMPTY}</p>
                    ) : (
                        <ul>
                            {usersList.map((user, index) => (
                                <li key={index} className="file-list-item">
                                    
                                    <span>{user.cognome} {user.cognome}  </span>
                                        <button onClick={() => handleRemoveUser(user.id, currentChat)} title="Rimuovi">
                                            <XIcon size={16} />

                                            </button>
                                    
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
        }     
        {addingUser  &&
                <div className="file-list">
                    <strong>{l.USERS_CONFIG_LIST}</strong>
                    {usersAddList.length === 0 ? (
                        <p>{l.USERS_CONFIG_LIST_EMPTY}</p>
                    ) : (
                        <ul>
                            {usersAddList.map((user, index) => (
                                <li key={index} className="file-list-item">
                                    
                                    <span>{user.cognome} {user.cognome}  </span>
                                     
                                    

                                        <button onClick={() => handleAddUser(user.id, currentChat)} title="Aggiungi">
                                                <PlusSquareIcon />            
                                        </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
        }     

                             

        {isEditing &&     
        <div className="config-form-container">
            {/* Form per i dati della Chat */}
            <form onSubmit={handleSubmitConfig}>
                <h2>{l.CHAT_CONFIG_FORM_TITLE}: {chatConfig.titolo}</h2>
                
                <div className="form-grid">
                    {/* Titolo */}
                    <div className="form-group">
                        <label htmlFor="titolo">{l.CHAT_CONFIG_LABEL_TITOLO}</label>
                        <input type="text" id="titolo" name="titolo" value={formData.titolo} onChange={handleChange} required />
                    </div>
                    {/* Stato */}
                    <div className="form-group">
                        <label htmlFor="stato">{l.CHAT_CONFIG_LABEL_STATO}</label>
                        <input type="text" id="stato" name="stato" value={formData.stato} onChange={handleChange} required />
                    </div>
                    {/* Username */}
                    <div className="form-group">
                        <label htmlFor="username">{l.CHAT_CONFIG_LABEL_USERNAME}</label>
                        <input type="text" id="username" name="username" value={formData.username} onChange={handleChange} required />
                    </div>
                    {/* CfgName */}
                    <div className="form-group">
                        <label htmlFor="cfgname">{l.CHAT_CONFIG_LABEL_CFGNAME}</label>
                        <input type="text" id="cfgname" name="cfgname" value={formData.cfgname} onChange={handleChange} required />
                    </div>
                </div>

                {/* CfgPrompt (Testo lungo) */}
                <div className="form-group full-width">
                    <label htmlFor="cfgprompt">{l.CHAT_CONFIG_LABEL_CFGPROMPT}</label>
                    <textarea id="cfgprompt" name="cfgprompt" value={formData.cfgprompt} onChange={handleChange} required />
                </div>
                <div className="form-group full-width">
                    <label htmlFor="cfgschema">{l.CHAT_CONFIG_LABEL_CFGSCHEMA}</label>
                    <textarea id="cfgschema" rows="40"name="cfgschema" value={formData.cfgschema} onChange={handleChange} required />
                </div>

                {/* Azioni Form Configurazione */}
                <div className="form-actions">      
                    <button type="button" className="cancel-button" onClick={onCancel}>
                        {l.ADMIN_BTN_CANCEL}
                    </button>
                    <button type="submit" className="save-button">
                        {l.CHAT_CONFIG_BTN_SAVE_CONFIG}
                    </button>
                </div>
            </form>

            {/* Sezione File Upload */}
            <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
                <h3>{l.CHAT_CONFIG_FILES_ASSOCIATED}</h3>
                <ul>
                    {/* Mappiamo ogni nome di file in un elemento della lista (li) */}
                    {chatFileList.files.map((fileName, index) => (
                        <li key={index} style={{ marginBottom: '8px' }}>
                                {fileName} - 
                              <button 
                                  className="smalls save-button"
                                  //disabled={loadingPdf}
                                  onClick={() => apriPdf(chatConfig.id ,  fileName)}
                                >
                                  Visualizza
                                </button>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="file-upload-section">
                <h3>{l.CHAT_CONFIG_UPLOAD_TITLE}</h3>
                <p>{l.CHAT_CONFIG_UPLOAD_DESC}</p>
                
                            {/* Bottone custom per selezionare file */}
                <label className="file-input-wrapper">
                    <UploadCloudIcon size={18} />
                    {l.CHAT_CONFIG_FILE_UPLOAD_BTN}
                    <input 
                        type="file" 
                        multiple 
                        onChange={handleFileChange} 
                        accept=".pdf,.md,.txt,.json" 
                        style={{ display: 'none' }} 
                    />
                </label>
                <p></p> 

                {/* Lista file selezionati */}
                <div className="file-list">
                    <strong>{l.CHAT_CONFIG_FILE_LIST_TITLE}</strong>
                    {selectedFiles.length === 0 ? (
                        <p>{l.CHAT_CONFIG_FILE_LIST_EMPTY}</p>
                    ) : (
                        <ul>
                            {selectedFiles.map((file, index) => (
                                <li key={index} className="file-list-item">
                                    <FileIcon size={16} />
                                    <span>{file.name}</span>
                                    <button onClick={() => handleRemoveFile(index)} title="Rimuovi">
                                        <XIcon size={16} />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Bottone Upload */}
                <div className="form-actions">
                    <button 
                        type="button" 
                        className="upload-button" 
                        onClick={handleUploadFiles}
                        disabled={selectedFiles.length === 0 || isUploading}
                    >
                        {isUploading ? l.AUTH_LOADING : l.CHAT_CONFIG_BTN_UPLOAD_FILES}
                    </button>
                </div>
            </div>
        </div>
        }
        </div>
    );
    
    // --- RENDER MENU PRINCIPALE ---

    const renderDashboard = () => (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            { profilo ==='admin' && 
            <div>

            <ActionCard
                title={l.CARD_USERS_TITLE}
                description={l.CARD_USERS_DESC}
                icon="??"
                onClick={() => setActiveTab('gestione_utenti')}
                /> 
                <p></p>
            <ActionCard
                title={l.CARD_CHATS_TITLE}
                description={l.CARD_CHATS_DESC2}
                icon="??"
                onClick={() => setActiveTab('gestione_chat')}
                />
           </div>
            }
            { profilo ==='user' && <ActionCard
                title={l.CARD_CHATS_TITLE}
                description={l.CARD_CHATS_DESC}
                icon="??"
                onClick={() => setActiveTab('gestione_chat')}
            />
        }
        </div>
    );
    
    const renderContent = ({handleLogout}) => {
        switch (activeTab) {
            case 'gestione_utenti':
                return profilo === 'admin' && renderUserManagement({handleLogout});
            case 'gestione_chat':
                return (profilo ==='user'  && renderChatManagement({handleLogout})) || (profilo === 'admin' && renderChatManagement({handleLogout}));
            default:
                return renderDashboard({handleLogout});
        }
    };

    return (
        <div className="admin-panel-container">
            <header className="header-input">
                 <table width="100%">
                    <tr>
                        <td width="25%">
                            {<img alt="log" width="45%" src="aimoxicona.png"/>}
                        </td>
                        <td align ="center">
                            <h1 className="text-3xl font-bold mb-6 text-gray-800">{l.ADMIN_TITLE}</h1>
                        </td>
                        <td align= "right"  width="25%">
                            {<div className="user-info-bar">
                        <button className="clear-button" onClick={handleLogout}  style={{ minWidth: '100px'}}>
                        {l.AUTH_BTN_LOGOUT}
                        </button>
                    </div>}
                        </td>
                    </tr>
                </table>   
            </header>
 
            <div className="tab-bar border-b border-gray-200 mb-6">
                <button 
                    className={`tab-button ${activeTab === 'dashboard' ? 'active' : ''}`}
                    onClick={() => setActiveTab('dashboard')}
                >
                    {l.ADMIN_TAB_DASHBOARD}
                </button>
                { profilo ==='admin' && 
                    <div>
                        <button 
                            className={`tab-button ${activeTab === 'gestione_utenti' ? 'active' : ''}`}
                            onClick={() => setActiveTab('gestione_utenti')}
                        >
                            {l.ADMIN_TAB_USERS}
                        </button> 
                        <button 
                        className={`tab-button ${activeTab === 'gestione_chat' ? 'active' : ''}`}
                            onClick={() => setActiveTab('gestione_chat')}
                        >
                            {l.ADMIN_TAB_CHATS}
                        </button>
                    </div>
                }
                 { profilo ==='user' && 
                <button 
                    className={`tab-button ${activeTab === 'gestione_chat' ? 'active' : ''}`}
                    onClick={() => setActiveTab('gestione_chat')}
                >
                    {l.ADMIN_TAB_CHATS}
                </button>
                }
            </div>

            <div className="admin-content">
                {renderContent({handleLogout})}
            </div>
       <Modal
        title="Visualizzazione Documento"
        open={pdfVisible}
        onCancel={chiudiPdf}
        footer={null}
        width="85%"
        style={{ top: 20 }}
        styles={{ body: { height: '85vh', padding: 0, overflow: 'hidden' } }}
        closeIcon={<X className='poi-back-button' style={{ fontSize: 20 }} />}
        destroyOnClose
        >
        {currentPdfUrl && (
            <iframe 
            src={currentPdfUrl.toLowerCase().endsWith('.pdf') ? `${currentPdfUrl}#view=FitH` : currentPdfUrl} 
            width="100%" 
            height="100%" 
            style={{ border: 'none', marginTop: 20 }} 
            title="File Viewer" 
            />
        )}
        </Modal>
        </div>
        
    );
};

export default AdminDashboard;